/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useSyncExternalStore } from 'react';

import { rateLimitStore, type RateLimitState } from './rateLimitStore';

export interface UseRateLimitResult extends RateLimitState {
    /**
     * Acknowledges the rate limit: dismisses the notice and suppresses further 429s
     * for what is left of the wait the visitor was told about — the reported one, or
     * the one-minute default. Dismissing late leaves proportionally less of it, since
     * the window ends where that wait ends rather than a whole wait from here
     */
    dismiss: () => void;
}

/**
 * Subscribes to global rate-limit state.
 *
 * Most services do not need this — `RateLimitModal` handles the standard notice.
 * Use it when a screen wants to react to being rate limited itself, e.g. disabling
 * a submit button while limited.
 */
export function useRateLimit(): UseRateLimitResult {
    const state = useSyncExternalStore(
        rateLimitStore.subscribe,
        rateLimitStore.getSnapshot,
        rateLimitStore.getSnapshot
    );

    return {
        ...state,
        dismiss: rateLimitStore.clear,
    };
}
